export * from '@fhs/routing/src/routes/claim-points';
export { default } from '@fhs/routing/src/routes/claim-points';
